import { patterns } from '../../../shared/constants/patterns';

export const validatePromoCode = (value: string) =>
  patterns.PROMO_CODE.test(value) || 'Invalid promo code';
